import React, { useState, useEffect } from 'react';
import NewNavbar from './components/NewNavbar';
import NewHero from './components/NewHero';
import NewAbout from './components/NewAbout';
import LoveStory from './components/LoveStory';
import NewProjects from './components/NewProjects';
import NewResume from './components/NewResume';
import NewFooter from './components/NewFooter';

import './styles/new-theme.css';

function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 400);
    return () => clearTimeout(timer);
  }, []);

  if (!loaded) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: '#0a0a0a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}
      >
        <div
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: '1.2rem',
            fontWeight: 700,
            color: '#ffffff',
            opacity: 0.6,
          }}
        >
          <span style={{ color: '#00ff88' }}>B</span>alaji
          <span style={{ color: '#00ff88' }}>.</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ background: '#0a0a0a', minHeight: '100vh' }}>
      <NewNavbar />
      <main>
        <NewHero />
        <NewAbout />
        <LoveStory />
        <NewProjects />
        <NewResume />
      </main>
      <NewFooter />
    </div>
  );
}

export default App;